import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Table.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "table-wrapper" }, [
    _c("table", { ref: "table", staticClass: "table" }, [
      _c("thead", [
        _c(
          "tr",
          { staticClass: "table-header-row" },
          _vm._l(_vm.columns, function(column, index) {
            return _c("TableHeaderCell", {
              key: column.id,
              attrs: {
                column: column,
                "sticky-left": _vm.stickyLeftColumn && index === 0,
                "sticky-right":
                  _vm.stickyRightColumn && index === _vm.columns.length - 1,
                "sticky-header": _vm.stickyHeader,
                sorted: _vm.sortedBy === column.id,
                "sorted-desc": _vm.sortedDesc
              },
              on: {
                sorted: function($event) {
                  return _vm.onSorted(column)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _vm._t(_vm.headerSlotName(column.id), null, null, props)
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.data, function(row) {
          return _c("TableRow", {
            key: row.id,
            attrs: {
              columns: _vm.columns,
              row: row,
              "sticky-right": _vm.stickyRightColumn,
              "sticky-left": _vm.stickyLeftColumn
            },
            on: {
              click: function($event) {
                return _vm.onRowClick(row, $event)
              }
            },
            scopedSlots: _vm._u(
              [
                _vm._l(_vm.columns, function(column) {
                  return {
                    key: column.id,
                    fn: function(props) {
                      return [_vm._t(column.id, null, null, props)]
                    }
                  }
                })
              ],
              null,
              true
            )
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "tfoot",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.infiniteScroll,
              expression: "infiniteScroll"
            }
          ]
        },
        [
          _c("tr", [
            _c(
              "td",
              {
                ref: "infinite-scroll-loader",
                staticClass: "infinite-scroll-loader",
                style: { width: _vm.tableWidth + "px" }
              },
              [_c("Spinner", { attrs: { size: "small" } })],
              1
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "busy-glass", attrs: { busy: _vm.busy } },
      [_c("Spinner")],
      1
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-d22f2e34";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Table/Table.vue.js